function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.72 9.75a2.531 2.531 0 012.53 2.531 1.125 1.125 0 002.25 0A4.78 4.78 0 0011.72 7.5a1.125 1.125 0 000 2.25z",
  fill: "url(#paint0_linear_498_42807)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.876 14.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z",
  fill: "url(#paint1_linear_498_42807)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 12.062V12a9 9 0 00-9-9h-.062a1.083 1.083 0 00-1.063 1.091v.07A1.099 1.099 0 0012 5.25 6.75 6.75 0 0118.75 12a1.125 1.125 0 001.125 1.125h.048A1.082 1.082 0 0021 12.062z",
  fill: "url(#paint2_linear_498_42807)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.34 19.939a2.25 2.25 0 002.532.973l2.458-.703a8.978 8.978 0 0011.492-3.766 1.091 1.091 0 00-.948-1.631h-.076a1.107 1.107 0 00-.956.562 6.733 6.733 0 01-8.798 2.686 1.468 1.468 0 00-1.052-.098l-2.742.787.796-2.787a1.34 1.34 0 00-.09-.967 6.733 6.733 0 012.67-8.84 1.108 1.108 0 00.562-.956v-.076a1.091 1.091 0 00-1.631-.948A8.977 8.977 0 003.79 15.672l-.684 2.394a2.326 2.326 0 00.234 1.873z",
  fill: "url(#paint3_linear_498_42807)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_498_42807",
  x1: "16.564",
  y1: "7.547",
  x2: "11.544",
  y2: "14.13",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".448",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: ".7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_498_42807",
  x1: "12.024",
  y1: "12.018",
  x2: "10.112",
  y2: "14.526",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".448",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: ".7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_498_42807",
  x1: "21.108",
  y1: "3.08",
  x2: "12.504",
  y2: "14.366",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".448",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: ".7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_498_42807",
  x1: "20.146",
  y1: "4.167",
  x2: "5.726",
  y2: "23.078",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".448",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: ".7"
})))));